



















import StarRating from 'vue-star-rating';

export default {
    name: 'BaseCardRestaurantAdvanced',
    components: {
        StarRating,
    },
    props: {
        item: Object,
    },
    data() {
        return {};
    },
    methods: {},
};
